const StatsCard = ({ count, label, valueColor, borderColor }) => {
  return (
    <div className={`bg-gray-900 border rounded-xl p-5 text-center ${borderColor}`}>
      <div className={`text-3xl font-bold mb-1 ${valueColor}`}>{count}</div>
      <div className="text-gray-500 text-sm font-medium">{label}</div>
    </div>
  );
};

export default StatsCard;
